import justOnlyLogoBlack from '../../../assets/images/common/logo_black_just-only.png'
import fightForYouLogoBlack from '../../../assets/images/common/logo_black_fightforyou.png'
import { getBrand } from '../../../config'
import { Icon } from '../Icon'
import { APP_NAME } from '../../../const'
import React from 'react'
export const LogoBlack = () => {
  if (getBrand() === "fightforyou") {
    return <Icon src={fightForYouLogoBlack} alt={APP_NAME} />
  }
  return <Icon src={justOnlyLogoBlack} alt={APP_NAME} />
}
